import { AuthService } from 'app/_services/auth.service';
import { Component } from '@angular/core';

import { NotificationService } from 'app/shared/utils/notification.service';

@Component({
  selector: 'sa-logout',
  template: `
    <div id="logout" (click)="showPopup()" class="transparent">
        <span> <a routerlink="/" title="Sair" data-action="userLogout"
                  data-logout-msg=""><i
          class="fa fa-sign-out fa-lg"></i></a> </span>
    </div>
  `,
  styles: []
})
export class LogoutComponent {

  constructor(
    private notificationService: NotificationService,
    private authService: AuthService) { }

  showPopup() {
    this.notificationService.smartMessageBox({
      title: `<i class='fa fa-sign-out fa-lg txt-color-white'></i>
                Deseja realmente sair ?`,
      content: '',
      buttons: '[Não][Sim]'

    }, (ButtonPressed) => {
      if (ButtonPressed === 'Sim') {
        this.logout()
      }
    });
  }

  logout() {
    this.authService.logout();
    location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/user/logout/logout.component.ts